


















import { Component, Vue } from "vue-property-decorator";
import router from "@/router";
import {
  BuildItem,
  BasicItem,
  BuildFromBasicItem,
  BasicItemIdList
} from "@/models/item";
import { item } from "@/store/index";

@Component({
  name: "item-build-sheet",
  components: {}
})
export default class ItemBuildSheet extends Vue {
  created() {
    item.separateBuildItem();
  }

  get buildItemEachBasicItem(): BuildFromBasicItem[] {
    return item.buildItemEachBasicItem;
  }

  pickAnotherBasicItemSrc(
    anBasicItemId: string,
    recipe: string[],
    item2: any
  ): string {
    const i = recipe.findIndex(x => x !== anBasicItemId);
    const anotherBasicId = [...recipe].splice(i, 1)[0];
    return item.basicItemList[anotherBasicId as BasicItemIdList].id;
  }
}
